import React from 'react';
import { CarouselSection } from '../../../components';
import { useHits } from 'react-instantsearch';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import {
  CREATOR_SEARCH_ID,
  CREATORS_WITH_SERIES,
  CREATORS_WITH_STREAMS,
  CREATORS_WITH_PODCASTS,
  FEATURED_CREATORS,
  FILMS_CREATORS_SECTION,
  LISTING_SEARCH_ID,
  NEW_TO_RABEL,
  NEWLY_RELEASED_FILMS,
  NEWLY_RELEASED_SERIES,
  NEWLY_RELEASED_STREAMS,
  NEWLY_RELEASED_PODCASTS,
  POPULAR_CREATORS,
  RECENT_RELEASES,
  TRENDING_CREATORS,
  TRENDING_FILMS,
  TRENDING_SERIES_CONTENT,
  TRENDING_STREAMS_CONTENT,
  TRENDING_PODCASTS,
  NEWLY_RELEASED_VERTICAL_VIDEOS,
  TRENDING_VERTICAL_VIDEOS_CONTENT,
} from '../../../constants';
import { createResourceLocatorString } from '../../../util/routes';
import { FILM_PRODUCTS, LIVE_EVENT_PRODUCTS, SERIES_PRODUCTS, PODCAST_PRODUCTS } from '../../../util/types';

const AuthAlogliaLandingPage = ({ sectionName, description, title, emptyCardData }) => {
  const { items, sendEvent } = useHits();
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();

  const routeToPage = () => {
    const creatorSections = [
      TRENDING_CREATORS,
      POPULAR_CREATORS,
      NEW_TO_RABEL,
      RECENT_RELEASES,
      FILMS_CREATORS_SECTION,
      FEATURED_CREATORS,
      CREATORS_WITH_SERIES,
      CREATORS_WITH_STREAMS,
      CREATORS_WITH_PODCASTS,
    ];

    const filmSections = [TRENDING_FILMS, NEWLY_RELEASED_FILMS];
    const seriesSections = [TRENDING_SERIES_CONTENT, NEWLY_RELEASED_SERIES];
    const streamsSections = [TRENDING_STREAMS_CONTENT, NEWLY_RELEASED_STREAMS];
    const podcastsSections = [TRENDING_PODCASTS, NEWLY_RELEASED_PODCASTS];

    if (sectionName === FEATURED_CREATORS) {
      history.push(
        createResourceLocatorString('CreatorLandingPage', routeConfiguration, {})
      );
      return;
    }

    const searchId = creatorSections.includes(sectionName) ? CREATOR_SEARCH_ID : LISTING_SEARCH_ID;
    const genrePageSections = [...filmSections, ...seriesSections, ...streamsSections, ...podcastsSections];

    const isGenreSection = genrePageSections.includes(sectionName);
    const genre = isGenreSection
      ? filmSections.includes(sectionName)
        ? FILM_PRODUCTS
        : seriesSections.includes(sectionName)
          ? SERIES_PRODUCTS
          : podcastsSections.includes(sectionName)
            ? PODCAST_PRODUCTS
            : LIVE_EVENT_PRODUCTS
      : null;

    const pageName = isGenreSection ? 'SearchPageGenre' : 'SearchPage';
    const pathParams = isGenreSection ? { searchId, genre } : { searchId };
    const searchParams = !isGenreSection ? { 'publicData.orientation' : 'vertical' } : {};

    history.push(
      createResourceLocatorString(pageName, routeConfiguration, pathParams, searchParams)
    );
  };

  return items?.length ? (
    <CarouselSection
      name={title?.trim() || sectionName}
      description={description}
      items={items}
      algolia={true}
      handleAction={routeToPage}
      emptyCardData={emptyCardData}
    />
  ) : null;
};

export default AuthAlogliaLandingPage;
